<template>
    <div class="community-content">
        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="refreshing event"></spinner>
        <div class="container">
<!--            <img src="../assets/community-icon.png" alt="TONE EVENT">-->
            <svg width="61px" height="50px" viewBox="0 0 61 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch -->
                <title>Page 1</title>
                <desc>Created with Sketch.</desc>
                <defs></defs>
                <g id="Group-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="01_Tone_Home_Unauthenticated" transform="translate(-127.000000, -2206.000000)" :stroke="getCorpHeaderColor" stroke-width="2">
                        <g id="Group-7-Copy-3" transform="translate(126.000000, 2175.000000)">
                            <path d="M24.5374934,65.012267 C22.5790733,65.012267 19.243945,64.7900847 17.4429019,64.4053966 L9.23192587,72.6163727 L9.23192587,60.9879935 C4.80797411,58.0078696 2,53.639042 2,48.7553018 C2,39.7775843 11.4426225,32.4983366 23.0901862,32.4983366 C34.7383893,32.4983366 44.1803723,39.7775843 44.1803723,48.7553018 C44.1803723,57.7330193 34.7377498,65.012267 23.0901862,65.012267 L24.5374934,65.012267 Z M44.5204304,38.6240915 C47.1558084,41.7216246 48.702081,45.4588977 48.702081,49.4780554 C48.702081,58.8707981 40.2839121,66.7115128 29.1703176,68.4451542 C32.3177945,69.8889815 35.9795445,70.7332924 39.9091744,70.7332924 C41.8675945,70.7332924 43.756055,70.5109693 45.5570981,70.1262812 L53.7680741,78.3372573 L53.7680741,66.7114361 C58.1920252,63.7313122 61,59.3624846 61,54.4761865 C61,46.7198836 53.9484087,40.2476649 44.5204943,38.6240147 L44.5204304,38.6240915 Z" id="Page-1"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <h2 style="text-transform:none;" v-bind:style="{ color: getCorpHeadingColor + ' !important'}">Join the Conversation at <span v-if="bannerEvent.type === '1'">TONE Live</span><span v-else>TONE Talk</span></h2>
            <div class="col-md-12 pinkbordercomp" v-if="bannerEvent && showRulesComp && showJoin(bannerEvent) && bannerEvent.type !== '3'">
                <rulescomp v-if="showRulesComp" :data="bannerEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
            </div>
            <!--<button class="button btn btn-pink btn-primary pull-center" title="Login or Signup to join the event"  v-if="showRulesComp && !user && showJoin(bannerEvent)" type="button" @click="joinEventUnAuth(bannerEvent)">&nbsp;Go to Event&nbsp</button>-->
                <!--<br />-->
                <!--<small>Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.</small></h2>-->
            <div class="communityBox" v-if="bannerEvent">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6" v-if="getExpert">
                        <jwplayer v-if="currentVideo" :data="currentVideo">Loading the player...</jwplayer>
                        <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                        <img v-if="!currentVideo" v-bind:src="bannerEvent.img_url" :alt="bannerEvent.title" :title="bannerEvent.title">
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6" v-if="bannerEvent && bannerEvent.csvExpertsNames">
                        <h2>{{bannerEvent.title}} with {{replaceLastExpert(bannerEvent.csvExpertsNames, ',', ' & ' )}}</h2>
                        <p v-if="bannerEvent">
                            {{bannerEvent.longDescription}}
                        </p>
                        <h5>{{getDateReference(bannerEvent.start_date, 'str')}}
                        </h5>
                        <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(bannerEvent)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                            Add to Calendar
                            <span class="start">{{bannerEvent.start_date}}</span>
                            <span class="end">{{bannerEvent.end_date}}</span>
                            <span class="timezone">America/New_York</span>
                            <span class="title">{{bannerEvent.title}}</span>
                            <span class="description">{{bannerEvent.longDescription}}</span>
                            <span class="location"><span v-if="bannerEvent.type === '1'">{{buildEventLink (bannerEvent.eventId) }}</span><span v-else>{{buildEventLink (bannerEvent.eventId) }}</span></span>
                        </div>
                        <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(bannerEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                            <i class="fa fa-share-square-o"></i> Share
                        </button>
                        <!--<button class="button btn btn-pink btn-primary pull-left"  v-if="showJoin(bannerEvent)" type="button" @click="joinEvent(bannerEvent)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp</button>-->
                        <!--time left in event {{timeLeftInEvent(getMainEvent.start_date)}}-->
                        <!--<button type="button" >Reserve your spot starting November 13th!</button>-->
                    </div>
                </div>
                <div class="col-md-12 pinkbordercomp"  :class="{ hidden: isHidden() }" v-if="bannerEvent && showRulesComp && !showJoin(bannerEvent) &&  bannerEvent.type !== '3'">
                    <rulescomp v-if="showRulesComp" :data="bannerEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
                </div>
                <div v-else>
                    <!--something went wrong-->
                </div>
            </div>
        </div>
        <br>
        <br>
        <modal v-if="showCorporateImageShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateImageShare" @cancel="cancelCorporateImageModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateImageModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                            <option value="Friends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="shareEventSelected.img_url" :alt="shareEventSelected.title" :title="shareEventSelected.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${shareEventSelected.title} | TONE Networks`}}</h4>
                        <p> {{`${shareEventSelected.longDescription.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateImageModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateImage()">
                            Share This Event
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
//    import slick from 'slick-carousel'
//    import $ from 'jquery'
    import { mapGetters } from 'vuex'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    import store from '../store'
    import jwplayer from './JwPlayer.vue'
    import rulescomp from './RulesComp.vue'
    import {spinner, modal} from 'vue-strap'
    import $ from 'jquery'
    export default {
        name: 'community',
        components: {
            jwplayer,
            rulescomp,
            spinner,
            modal
        },
        metaInfo () {
            let self = this
            return {
                title: 'TONE Upcoming Events |' + self.sTitle,
                meta: [
                    {property: 'og:image', content: self.sImage},
                    {property: 'og:title', content: self.sTitle},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: self.sDescription
                    },
                    {property: 'twitter:title', content: self.sTitle},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.sImage},
                    {
                        property: 'twitter:description',
                        content: self.sDescription
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                shareImagePayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    eventId: '',
                    customizedMessage: '',
                    playlistType: 6
                },
                shareEventSelected: null,
                showCorporateImageShare: false,
                corporateShareMessage: '',
                selectedPlaylist: null,
                corpShareModalImage: '',
                showCorporateShare: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareOption: 'Corporate',
                spinner: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                toggleSpinner: false,
                showRulesComp: false,
                videoRef: '',
                currentVideo: null,
                reservationMsg: '',
                bannerEvent: null,
                eventURL: 'https://www.tonenetworks.com',
                sImage: '',
                sTitle: '',
                sDescription: '',
                timeTostartEvent: 0,
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                }
            }
        },
        watch: {
            'bannerEvent' (to, from) {
                let self = this
                if (self.bannerEvent && self.bannerEvent.eventId > 0) {
                    self.sTitle = self.bannerEvent.type === '1' ? 'TONE Live: ' + self.bannerEvent.title : 'TONE Talk: ' + self.bannerEvent.title
                    self.sImage = self.bannerEvent.img_url
                    self.sDescription = self.bannerEvent.longDescription
                    self.showRulesComp = true
                    self.$store.dispatch('CACHEPAGE', window.location.href)
                    self.calculateTimeToStartEvent(self.bannerEvent.start_date, self.bannerEvent.end_date, self.bannerEvent.eventSwitchTime, self.getEventSwitchTime)
                    if (self.bannerEvent.jw_stream_title && self.bannerEvent.jw_stream_title.length > 2) {
                        self.$store.dispatch('GETCURRENTVIDEO', self.bannerEvent.jw_stream_title).then(() => {
                            if (self.getCurrentVideo) {
                                let videoObj = self.getCurrentVideo[0]
                                self.currentVideo = {
                                    video: videoObj.sources[videoObj.sources.length - 1].file,
                                    title: videoObj.title,
                                    img: videoObj.image,
                                    playerID: new Date(),
                                    tracks: videoObj.tracks,
                                    Description: videoObj.description,
                                    mediaId: videoObj.mediaid,
                                    isMute: true
                                }
                                self.videoRef = window['currentVideoId']
                            }
                        })
                    }
                } else {
                }
            },
            'shareOption' (to, from) {
                let self = this
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []
            }
        },
        mounted: function () {
            setTimeout(function () {
                window.addeventatc.refresh()
            }, 2000)
            let eventIdParam = this.$route.params.eventId
            // Redirection no longer required since events have passed
            // if (eventIdParam) {
            //     if (eventIdParam.toString() === '123' || eventIdParam.toString() === '124' || eventIdParam.toString() === '125' || eventIdParam.toString() === '126' || eventIdParam.toString() === '144' || eventIdParam.toString() === '146' || eventIdParam.toString() === '147' || eventIdParam.toString() === '139' || eventIdParam.toString() === '140' || eventIdParam.toString() === '141') {
            //         this.$router.push('/corporation/mycommunity')
            //     }
            // }
            var self = this
            let apiName = 'GETEVENTLIST'
            if (self.user && self.user.adminAccessLevel === 1) {
                apiName = 'GETADMINEVENTS'
            }
            console.info(3)
            if (eventIdParam) {
                this.$store.dispatch(`${apiName}`).then(() => {
                    if (this.getEventList) {
                        console.info(4)
                        let getEvt = this.getEventList.filter(ev => {
                            return ev.eventId.toString() === eventIdParam.toString()
                        })
                        console.log('found event', getEvt)
                        if (getEvt && getEvt.length > 0) {
                            self.eventId = getEvt[0].eventId
                            this.$store.dispatch('SETBANNEREVENT', getEvt[0].eventId).then(() => {
                            })
                            this.bannerEvent = getEvt[0]
                            this.$store.dispatch('GETEXPERT', getEvt[0].expertId).then(() => {
                                if (self.bannerEvent.type === '1') {
                                    self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                    self.sImage = self.bannerEvent.img_url
                                    self.sDescription = self.bannerEvent.longDescription
                                } else {
                                    self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                    self.sImage = self.bannerEvent.img_url
                                    self.Description = self.bannerEvent.longDescription
                                }
                            })
                        } else { // Given Event Not found
                            let currentDate = this.returnEasternTime()
                            let eMonth = currentDate.getMonth() + 1
                            eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                            let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                            let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                            // Get Events on given Day
                            let eventsOnDate = this.getEventList.filter(ev => {
                                return ev.start_date.substr(0, 10) === formattedDate
                            })
                            // Get Events other than current Day
                            let eventsNotOnDate = this.getEventList.filter(ev => {
                                return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                            })
                            if (eventsOnDate && eventsOnDate.length > 0) {
                                if (this.isEventToday(eventsOnDate[0].end_date)) {
                                    self.eventId = eventsOnDate[0].eventId
                                    this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {})
                                    if (self.eventId > 0) {
                                        if (self.getEventList) {
                                            let ev = this.getEventList.filter(ev => {
                                                return ev.eventId === self.eventId
                                            })
                                            if (ev && ev.length > 0) {
                                                this.bannerEvent = ev[0]
                                                this.$store.dispatch('GETEXPERT', ev[0].expertId).then(() => {
                                                    if (self.bannerEvent.type === '1') {
                                                        self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                        self.sImage = self.bannerEvent.img_url
                                                        self.sDescription = self.bannerEvent.longDescription
                                                    } else {
                                                        self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                        self.sImage = self.bannerEvent.img_url
                                                        self.Description = self.bannerEvent.longDescription
                                                    }
                                                })
                                            }
                                        }
                                    } else {
                                        console.info('1')
                                        this.$router.push(`/`)
                                    }
                                } else {
                                    // Display next event in queue
                                    if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                        self.eventId = eventsNotOnDate[0].eventId
                                        this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                        if (self.eventId > 0) {
                                            if (self.getEventList) {
                                                let ev = this.getEventList.filter(ev => {
                                                    return ev.eventId === self.eventId
                                                })
                                                if (ev && ev.length > 0) {
                                                    this.bannerEvent = ev[0]
                                                    this.$store.dispatch('GETEXPERT', ev[0].expertId).then(() => {
                                                        if (self.bannerEvent.type === '1') {
                                                            self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                            self.sImage = self.bannerEvent.img_url
                                                            self.sDescription = self.bannerEvent.longDescription
                                                        } else {
                                                            self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                            self.sImage = self.bannerEvent.img_url
                                                            self.Description = self.bannerEvent.longDescription
                                                        }
                                                    })
                                                }
                                            }
                                        } else {
                                            console.info('2')
                                            this.$router.push(`/`)
                                        }
                                    }
                                }
                            } else {
                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                    self.eventId = eventsNotOnDate[0].eventId
                                    this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                    if (self.eventId > 0) {
                                        if (self.getEventList) {
                                            let ev = this.getEventList.filter(ev => {
                                                return ev.eventId === self.eventId
                                            })
                                            if (ev && ev.length > 0) {
                                                this.bannerEvent = ev[0]
                                                this.$store.dispatch('GETEXPERT', ev[0].expertId).then(() => {
                                                    if (self.bannerEvent.type === '1') {
                                                        self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                        self.sImage = self.bannerEvent.img_url
                                                        self.sDescription = self.bannerEvent.longDescription
                                                    } else {
                                                        self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                        self.sImage = self.bannerEvent.img_url
                                                        self.Description = self.bannerEvent.longDescription
                                                    }
                                                })
                                            }
                                        }
                                    } else {
                                        console.info('3')
                                        this.$router.push(`/`)
                                    }
                                }
                            }
                        }
                    }
                })
            } else {
                this.$store.dispatch('GETEVENTLIST').then(() => {
                    if (this.getEventList) {
                        let currentDate = this.returnEasternTime()
                        let eMonth = currentDate.getMonth() + 1
                        eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                        let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                        let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                        // Get Events on given Day
                        let eventsOnDate = this.getEventList.filter(ev => {
                            return ev.start_date.substr(0, 10) === formattedDate
                        })
                        // Get Events other than current Day
                        let eventsNotOnDate = this.getEventList.filter(ev => {
                            return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                        })
                        if (eventsOnDate && eventsOnDate.length > 0) {
                            if (this.isEventToday(eventsOnDate[0].end_date)) {
                                self.eventId = eventsOnDate[0].eventId
                                this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {})
                                if (self.eventId > 0) {
                                    if (self.getEventList) {
                                        let ev = this.getEventList.filter(ev => {
                                            return ev.eventId === self.eventId
                                        })
                                        if (ev && ev.length > 0) {
                                            this.bannerEvent = ev[0]
                                            this.$store.dispatch('GETEXPERT', ev[0].expertId).then(() => {
                                                if (self.bannerEvent.type === '1') {
                                                    self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                    self.sImage = self.bannerEvent.img_url
                                                    self.sDescription = self.bannerEvent.longDescription
                                                } else {
                                                    self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                    self.sImage = self.bannerEvent.img_url
                                                    self.Description = self.bannerEvent.longDescription
                                                }
                                            })
                                        }
                                    }
                                } else {
                                    console.info('4')
                                    this.$router.push(`/`)
                                }
                            } else {
                                // Display next event in queue
                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                    self.eventId = eventsNotOnDate[0].eventId
                                    this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                    if (self.eventId > 0) {
                                        if (self.getEventList) {
                                            let ev = this.getEventList.filter(ev => {
                                                return ev.eventId === self.eventId
                                            })
                                            if (ev && ev.length > 0) {
                                                this.bannerEvent = ev[0]
                                                this.$store.dispatch('GETEXPERT', ev[0].expertId).then(() => {
                                                    if (self.bannerEvent.type === '1') {
                                                        self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                        self.sImage = self.bannerEvent.img_url
                                                        self.sDescription = self.bannerEvent.longDescription
                                                    } else {
                                                        self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                        self.sImage = self.bannerEvent.img_url
                                                        self.Description = self.bannerEvent.longDescription
                                                    }
                                                })
                                            }
                                        }
                                    } else {
                                        console.info('5')
                                        this.$router.push(`/`)
                                    }
                                }
                            }
                        } else {
                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                self.eventId = eventsNotOnDate[0].eventId
                                this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {})
                                if (self.eventId > 0) {
                                    if (self.getEventList) {
                                        let ev = this.getEventList.filter(ev => {
                                            return ev.eventId === self.eventId
                                        })
                                        if (ev && ev.length > 0) {
                                            this.bannerEvent = ev[0]
                                            this.$store.dispatch('GETEXPERT', ev[0].expertId).then(() => {
                                                if (self.bannerEvent.type === '1') {
                                                    self.sTitle = `TONE Live: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                    self.sImage = self.bannerEvent.img_url
                                                    self.sDescription = self.bannerEvent.longDescription
                                                } else {
                                                    self.sTitle = `TONE Talk: ${self.bannerEvent.title} with ${self.getExpert[0].name}`
                                                    self.sImage = self.bannerEvent.img_url
                                                    self.Description = self.bannerEvent.longDescription
                                                }
                                            })
                                        }
                                    }
                                } else {
                                    console.info('6')
                                    this.$router.push(`/`)
                                }
                            }
                        }
                    }
                })
            }
            if (self.user) {
                // Get Tagged Email List
                self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                    if (self.getTaggedEmailList) {
                        self.emailList = []
                        self.emailList = self.getTaggedEmailList
                        console.log('email list', self.getTaggedEmailList)
                    }
                })
                // Get Corporatin Payload if user is part of corporation
                this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                    this.allCorps = []
                    if (this.getCorporatePayload) {
                        this.corporateInfo = this.getCorporatePayload
                        this.allCorps = this.corporateInfo.lstCorporationUsers
                    }
                })
            }
        },
        methods: {
            replaceLastExpert (strArray, chr, newChr) {
                var a = strArray.split('')
                a[strArray.lastIndexOf(chr)] = newChr
                return a.join('').replace('/,/g', ', ')
            },
            shareCorporateImage () {
                let self = this
                self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareImagePayload.senderUserId = self.user.userId
                self.shareImagePayload.recipientsUserIds = []
                self.shareImagePayload.recipientFriendEmails = null
                self.shareImagePayload.customizedMessage = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareImagePayload.recipientsUserIds = []
                    self.shareImagePayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareImagePayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareImagePayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareImagePayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareImagePayload.eventId = self.shareEventSelected.eventId
                self.shareInProcess = true
                // Send the Email
                self.$store.dispatch('CORP_EVENT_SHARE', {payload: self.shareImagePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: 'Event has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    } else {
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    }
                })
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            openCorporateImageShareModal (tEvent) {
                console.log('event for share', tEvent)
                let self = this
                self.shareInProcess = false
                self.shareEventSelected = tEvent
                self.corpShareModalImage = tEvent.img_url
                self.corpShareModalDesc = tEvent.description
                self.corpShareModalTitle = tEvent.title
                self.showCorporateImageShare = true
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            cancelCorporateImageModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateImageShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            getExpertInfo (expertId, info) {
                let reqInfo
                if (this.getAllExperts) {
                    let expert = this.getAllExperts.filter(exp => {
                        return exp.expertId === expertId
                    })
                    if (info === 'name') {
                        reqInfo = expert[0].name
                    } else if (info === 'img') {
                        reqInfo = expert[0].small_image
                    } else if (info === 'biography') {
                        reqInfo = expert[0].biography
                    } else if (info === 'experties') {
                        reqInfo = expert[0].experties
                    }
                }
                return reqInfo
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            isUserEntrolled (eventId) {
                if (this.getUserEvents) {
                    let filter = this.getUserEvents.filter(ev => {
                        return ev.eventId === eventId
                    })
                    if (filter && filter.length > 0) {
                        return true
                    }
                }
                return false
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            isEventToday (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            isEventToday2 (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            timeLeftInEvent (evtDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                return this.getMinutesBetweenDates(currentDate, eventDate)
            },
            joinEventUnAuth (event) {
                let joinString = `/event/${event.eventId}`
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', joinString)
                } else {
                    sessionStorage.setItem('redirectPath', joinString)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
                // this.$router.push(`/rules/` + event.eventId)
                // this.$router.push(`/rules/` + event.eventId)
            },
            enrollUser (event) {
                if (event.eventId === 1) {
                    window.logEvents('Events Page', 'Tone Live Seat Reserved', `Event Title: ${event.title}`)
                } else {
                    window.logEvents('Events Page', 'Tone Talk Seat Reserved', `Event Title: ${event.title}`)
                }
                this.seatReservation.eventId = event.eventId
                this.seatReservation.userId = this.user.userId
                this.seatReservation.status = '1'
                this.seatReservation.isAnonymous = '0'
                this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                    this.$store.dispatch('GETALLEXPERTS').then(() => {
                    })
                    this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    })
                })
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            triggerLogin () {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/events`)
                } else {
                    sessionStorage.setItem('redirectPath', `/events`)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            showJoin (bEvent) {
                if (this.isEventToday2(bEvent.start_date, bEvent.end_date, bEvent.eventSwitchTime, this.getEventSwitchTime)) {
                    return true
                }
                return false
            },
            calculateTimeToStartEvent (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let self = this
                let eventDate = new Date(evtDate)
//                let eventEndDate = new Date(endDate)
                let currentDate = this.returnEasternTime()
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                console.log('time left in event', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                        console.log('event joining enabled')
                    } else {
                        console.log('difference', self.getMinutesBetweenDates(currentDate, eventDate))
                        console.log('switch time', switchTime)
                        console.log('time left', self.getMinutesBetweenDates(currentDate, eventDate) - switchTime)
                        let timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime
                        if (timeToStart > 0 && timeToStart <= 90) {
                            console.log('view needs to be freshed after: ', timeToStart)
                            let timeToTrigger = parseInt(timeToStart * 60 * 1000)
                            console.log('trigger in seconds', timeToTrigger)
                            setTimeout(() => {
                                console.info('refreshing view')
                                self.toggleSpinner = true
                                self.showRulesComp = false
                                setTimeout(() => {
                                    self.showRulesComp = true
                                    self.toggleSpinner = false
                                }, 1500)
                            }, timeToTrigger + 60)
                        }
                    }
                }
            },
            buildEventLink (EVENT_ID) {
                let href = window.location.href
                let calendarLink = ''
                console.log('Community.vue -> buildEventLink() : href = ', href)
                console.log('Community.vue -> buildEventLink() : EVENT_ID = ', EVENT_ID)
                if (this.user && this.user.corporation && this.user.corporation.corporationId === 200) {
                    if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                        calendarLink = 'https://www1.dev-tonenetworks.com/horizonssotest?corporationId=200&redirect_uri=https://www1.dev-tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    } else {
                        calendarLink = 'https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    }
                    //  https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/294
                } else {
                    calendarLink = this.eventURL + '/event/' + EVENT_ID // this.getMainEvent.eventId
                    // https://www.tonenetworks.com/event/294
                }
                return calendarLink
            },
            isHidden () {
                // let self = this
                console.log('EVENT : isHidden()')
                let eventCorporationId = ''
                if (localStorage.getItem('event_corporation_id')) {
                    eventCorporationId = localStorage.getItem('event_corporation_id')
                }
                console.log('EVENT : isHidden() ::: eventCorporationId = ', eventCorporationId)
                return eventCorporationId === '200' // || this.$route.params.corporateId === '200'
            }
        },
        computed: {
            ...mapGetters(
                ['user', 'error', 'getExpert', 'getEventList', 'getMainEvent', 'getTalkEvents', 'getLiveEvents', 'getLiveExperts', 'getTalkExperts', 'getBannerEvent', 'getEventSwitchTime', 'getCurrentVideo', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTaggedEmailList', 'getCorporatePayload']
            )
        }

    }
</script>
<style scoped>
    .community-content h2 {
        margin: 0 0 20px;
    }

    h2 + button.button.btn.btn-pink.btn-primary.pull-center {
        margin: 0 auto 30px;
    }

    .community-content .communityBox h2 {
        margin:  0 0 20px;
        line-height: 1.3;
    }

    .community-content .communityBox p {
        margin: 0 0 20px;
    }
    .community-content .sliderEventBox .slick-slide img {
        object-fit: cover;
        object-position: center;
        height:auto;
    }
    .sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent {
        border-radius: 3px;
        margin: 20px 0 0;
    }

    .sliderEventBox p {
        min-height: 155px;
    }
    /*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled ,*/
    /*.sliderEventBox button.btn.btn-danger.expert-section-btn.btn-transparent.disabled:hover {*/
        /*background: transparent;*/
        /*color: #e08383 !important;*/
    /*}*/
    @media(min-width:768px){
        .sliderTalkBox>h2+p {
            position: relative;
            top: -40px;
            color: #303030;
            font-size: 15px;
            font-weight: 500;
            font-family: sans-serif;
            letter-spacing: 0.3px;
        }
        .community-content .sliderEventBox {
            margin: 70px 0 100px 0;
        }
    }
    .community-content .communityBox button{width:auto;}
    .community-content .communityBox h5 {
        margin: 0 0 35px 0;
    }
    .community-content .sliderTalkBox .slick-slide p {
        margin: 0 0 20px 0;
        color: #303030;
        font-size: 14px;
        line-height: 22px;
        font-family: sans-serif;
        padding: 0 10px 0 10px;
        text-align: left;
        letter-spacing: 0.5px;
    }
    .selected-event {
        content: "\F00C";
        font: normal normal normal 14px/1 FontAwesome;
        position: absolute;
        color: white;
        right: 20.5px;
        top: 24px;
        font-size: 18px;
    }
    .slick-slide button.button {
        color: #f0617d;
        border: 1px solid #f0617d;
        background: none;
        outline: none;
        font-size: 16px;
        font-family: sans-serif;
        letter-spacing: 0.3px;
        float: left;
        margin-left: 10px;
        width: 278px;
        padding: 18px 15px 14px;
        border-radius: 3px;
        margin-top: 10px;
    }
    .sliderTalkBox .slider p {
        min-height: 160px;
    }
    .community-content .sliderTalkBox .slick-slide h5 {
        text-align: left;
        padding: 0 10px;
    }
    .sliderTalkBox .slider h2{
        color: #303030;
        margin: 15px 0 15px 0;
        line-height: 31px;
        text-align: left;
        font-family: sans-serif;
        padding: 0 20px 0 10px;
        font-size: 20px;
        text-transform: inherit;
    }
    .slick-slide .addeventatc.pinkoutlinebtn {
        padding: 11px 12px 11px 37px !important;
    }

    button.share-event {
        color: rgb(240, 97, 125) !important;
        border: 1px solid rgb(240, 97, 125) !important;
        background-image: none !important;
        font-weight: 600;
        line-height: 100%;
        background: #fff !important;
        font-size: 15px !important;
        text-decoration: none;
        border-radius: 3px !important;
        cursor: pointer;
        -webkit-font-smoothing: antialiased!important;
        outline-color: rgba(0,78,255,0.5) !important;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);
        display: inline-block;
        position: relative;
        /*z-index: 99998;*/
        font-family: "Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif !important;
        padding: 12px 12px 12px 12px !important;
        margin-left: 10px !important;
        width: 173px !important;
        display: inline-block;
        float: left !important;
        box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;
    }
    .addeventatc.pinkoutlinebtn {
        float: left;
    }
    @media(max-width:991px){
        .community-content .communityBox .addeventatc.pinkoutlinebtn{
            margin-left:0 !important;
            margin-right:10px;
            margin-bottom:10px;
        }
        .community-content .communityBox button.share-event{
            margin-left:0 !important;
        }
    }
    @media(max-width:767px){
        .community-content .communityBox .addeventatc.pinkoutlinebtn{
            margin-left:15px !important;
        }
        .community-content .communityBox button.share-event{
            margin-left:15px !important;
        }
    }

    .slick-slide .addeventatc.pinkoutlinebtn {
        padding: 13px 12px 12px 37px !important;
    }

    .slick-slide button.share-event {
        width: auto !important;
        margin: 10px;
    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .modal {
        z-index: 999999;
    }
    .community-content .communityBox h2 {
        /*color: #44bda8;*/
        font-size: 24px;
    }
    .community-content .communityBox {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// Event.vue?a004558c